import { render } from "./crawler.vue?vue&type=template&id=2a501b5e&ts=true"
import script from "./crawler.vue?vue&type=script&lang=ts"
export * from "./crawler.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__